import React, { useEffect } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { InviteResponse, useDeleteInviteMutation, useResendInviteMutation } from '../../store/auth/auth'
import { Controller, useForm } from 'react-hook-form'
import { FormFeedback } from '../../components/Form/FormFeedback'
import { Button } from '../../components/Button/Button'
import { useJoinAdhocMeetingMutation } from '../../store/media/media'

interface ResendInviteModalProps {
  invite?: InviteResponse
  show: boolean
  onHide: () => void
}

export const ResendInviteModal: React.FC<ResendInviteModalProps> = ({ invite, show, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const [resendInvite, resendInviteResult] = useResendInviteMutation()

  type FormValues = {
    ccMe: boolean
  }

  const defaultValues = {
    ccMe: false,
  }

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>({ defaultValues })

  useEffect(() => {
    if (resendInviteResult.isSuccess) {
      onHide()
    }
  }, [resendInviteResult])

  if (!invite) {
    return null
  }

  const onSubmit = async (data: FormValues) => {
    if (invite) {
      resendInvite({ accountId: accountId, inviteId: invite.id, body: { ccMe: data.ccMe } })
    }
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Resend Invitation</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to resend invitation for email <b>{invite.user.email}</b> ?
          </div>
          <form className='d-flex gap-2'>
            <Controller
              name='ccMe'
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Form.Check type='checkbox' checked={field.value === true} onChange={field.onChange} label='Send invitation copy to me' />
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </>
              )}
            />
          </form>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleSubmit(onSubmit)}
      footerPrimaryActionLoading={resendInviteResult.isLoading}
      footerPrimaryActionTitle='Resend'
    ></Modal>
  )
}
